const productTypes = [
    { key: '4', value: '4', text: 'Créditos' },
    { key: '1', value: '1', text: 'Matrículas y Pensiones' },
    { key: '3', value: '3', text: 'Cupo de Crédito (Tarjeta de Afiliación)' },
    { key: '10', value: '10', text: 'Reserva de hoteles' },
  ];
  
  export default productTypes;
  